import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { M2PositionsEdit } from "./edit";
import { M2PositionsNew } from "./new";
import { M2PositionsTable } from "./table";

export default function M2Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path="new" element={<M2PositionsNew />} />
      <Route path=":id" element={<M2PositionsEdit />} />
      <Route index element={<M2PositionsTable />} />
    </Routes>
  );
}
